




























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import MetaValuation from '@/views/MetaValuation.vue';
import MetaCompany from '@/views/MetaCompany.vue';
import MetaCompetitors from '@/views/MetaCompetitors.vue';
import MetaClosingMeeting from '@/views/MetaClosingMeeting.vue';
import MetaPreClosingMeeting from '@/views/MetaPreClosingMeeting.vue';
import MetaFutureMeeting from '@/views/MetaFutureMeeting.vue';
import MetaYearEndMeeting from '@/views/MetaYearEndMeeting.vue';
import MetaYearReview from '@/views/MetaYearReview.vue';
import { CompanyDocument } from '../store/models';
import axios from 'axios';
import * as api from '@/store/api';

@Component({components: {MetaValuation, MetaCompany, MetaCompetitors,
        MetaClosingMeeting, MetaPreClosingMeeting, MetaFutureMeeting, MetaYearEndMeeting, MetaYearReview}})
export default class CardDocuments extends CompanyMixin {
    selectedModel: any = {};
    downloading: boolean = false;

    @Watch('documents', { immediate: true, deep: true })
    onDocumentsChanged() {
        if (this.documents && !this.selected) {
            if (user.selectedDocument) {
                for (const doc of this.documents) {
                    if (doc.DocumentId === user.selectedDocument) {
                        this.selectedModel = doc;
                        return;
                    }
                }
            }
            if (this.documents.length > 0) {
                this.selectedModel = this.documents[0];
            }
        }
    }

    @Watch('selected', { immediate: true, deep: true })
    async onSelectionChanged() {
        if (this.selected) {
            await user.setSelectedDocument(this.selected.DocumentId);
            await user.setSelectedDocumentBlob(this.selected.Id);
        }
    }

    getTitle(type: string) {
        switch (type) {
            case 'company': {
                return 'Bolagsanalys';
            }
            case 'competitors': {
                return 'Konkurrentjämförelse';
            }
            case 'valuation': {
                return 'Förenklad kassaflödesvärdering';
            }
            case 'closingmeeting': {
                return 'Bokslutsmöte';
            }
            case 'preclosingmeeting': {
                return 'Inför Bokslut';
            }
            case 'futuremeeting': {
                return 'Framtidsmöte';
            }
            case 'yearendmeeting': {
                return 'Årsavslutsmöte';
            }
            case 'yearreview': {
                return 'Årsgenomgång';
            }
        }
        return type;
    }

    gotoPresentation() {
        if (this.selected) {
            this.openFullscreen();
            const r = this.$router;
            switch (this.selected.Data.Type) {
                case 'company': {
                    r.push({name: 'presentation-company', params: {DocumentId: this.selected.Id}});
                    break;
                }
                case 'competitors': {
                    r.push({name: 'presentation-competitors', params: {DocumentId: this.selected.Id}});
                    break;
                }
                case 'valuation': {
                    r.push({name: 'presentation-valuation', params: {DocumentId: this.selected.Id}});
                    break;
                }
                case 'closingmeeting': {
                    r.push({name: 'presentation-closingmeeting', params: {DocumentId: this.selected.Id}});
                    break;
                }
                case 'preclosingmeeting': {
                    r.push({name: 'presentation-preclosingmeeting', params: {DocumentId: this.selected.Id}});
                    break;
                }
                case 'futuremeeting': {
                    r.push({name: 'presentation-futuremeeting', params: {DocumentId: this.selected.Id}});
                    break;
                }
                case 'yearendmeeting': {
                    r.push({name: 'presentation-yearendmeeting', params: {DocumentId: this.selected.Id}});
                    break;
                }
                case 'yearreview': {
                    r.push({name: 'presentation-yearreview', params: {DocumentId: this.selected.Id}});
                    break;
                }
            }
        }
    }

    download(template: string, fileName: string) {
        this.downloading = true;
        axios({
                method: 'get',
                url: this.targetUri(template),
                responseType: 'arraybuffer',
            })
            .then((response) => {
                this.downloading = false;
                this.forceFileDownload(response, fileName);
            })
            .catch(() => {
                this.downloading = false;
                console.log('error occured');
            });
    }

    targetUri(template: string) {
        if (!this.selected) {
            return '';
        }
        return `/api/user/render/${this.selected.Id}/${template}`;
    }

    forceFileDownload(response: any, fileName: string) {
        const data = new Blob([response.data], {type: 'application/pdf'});

        // IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(data, fileName);
            return;
        }

        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(url);
        }, 100);
    }

    open(path: string) {
        window.open(path, '_blank');
    }

    openFullscreen() {
        const elem: any = document.documentElement;
        if (elem.requestFullscreen) {
        return elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
        return elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        return elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
        return elem.msRequestFullscreen();
        }
    }

    editDocument() {
        if (!this.selected) {
            return;
        }
        this.$router.push({name: 'editdocument'});
    }

    async deleteDocument() {
        const res = await this.$bvModal.msgBoxConfirm('Vill du ta bort dokumentet?', {
            title: 'Bekräftelse',
            okTitle: 'Ja',
            cancelTitle: 'Nej',
            buttonSize: 'lg',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
        });
        if (res && user.selectedDocument) {
            await api.deleteDocument(user.selectedDocument);
            await user.setSelectedDocument(null);
            await user.setSelectedDocumentBlob(null);
            this.selectedModel = {};
            await user.getUser('Tar bort dokument');
        }
    }

  get selected(): CompanyDocument | undefined {
    if (this.selectedModel.Created) {
      return this.selectedModel;
    } else {
      return undefined;
    }
  }

  get pending() {
    return false;
  }
}
